module.exports = __webpack_public_path__ + "static/media/internship-cover-Mobile.ec09f23c.png";